import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-under-liquidation-dialog',
  templateUrl: './under-liquidation-dialog.component.html',
  styleUrls: ['./under-liquidation-dialog.component.scss']
})
export class UnderLiquidationDialogComponent {
  constructor(
    @Optional() public matDialogRef?: MatDialogRef<UnderLiquidationDialogComponent>,
    @Optional() public cdkDialogRef?: DialogRef<UnderLiquidationDialogComponent>
  ) {}

  close(): void {
    if (this.matDialogRef) {
      this.matDialogRef.close();
    } else if (this.cdkDialogRef) {
      this.cdkDialogRef.close();
    }
  }
}
